import {createApp, PropType} from 'vue';
import {connectVue} from '../modules/configureBugsnag';
import configureGlobalComponents from '../modules/configureGlobalComponents';
import useCarWorthForm from '../composables/home/useCarWorthForm';
import useLookingToBuyTabs from '../composables/home/useLookingToBuyTabs';
import useMakeModelForm from '../composables/home/useMakeModelForm';

const app = createApp({
    props: {
        usedCarMakes: {type: Array as PropType<DropdownOptions>, required: true},
        newCarMakes: {type: Array as PropType<DropdownOptions>, required: true},
        van: {type: Boolean, required: true},
    },
    setup(props) {
        const {
            carWorthVrm,
            carWorthMileage,
            carWorthValidator,
            onCarWorthSubmit,
        } = useCarWorthForm();

        const {
            ltbTab,
            changeLtbTab,
        } = useLookingToBuyTabs();

        const {
            condition,
            make,
            model,
            loading,
            vehicleConditions,
            vehicleMakes,
            vehicleModels,
            goToMakeModelPage,
            goToVanMakeModelPage,
            goToNewDriverModelPage,
            makeModelSearchUrl,
        } = useMakeModelForm(props.usedCarMakes, props.newCarMakes, props.van);

        return {
            carWorthVrm,
            carWorthMileage,
            v$: carWorthValidator,
            onCarWorthSubmit,
            ltbTab,
            changeLtbTab,
            condition,
            make,
            model,
            loading,
            vehicleConditions,
            vehicleMakes,
            vehicleModels,
            goToMakeModelPage,
            goToVanMakeModelPage,
            goToNewDriverModelPage,
            makeModelSearchUrl,
        };
    },
}, window.propsData);

connectVue(app);
configureGlobalComponents(app);
app.mount('#used-van-search');
